import { SurveyObject, ISurveyQuestion } from '../Client/ISurvey'
import { SurveyTrigger } from '../screens/Components/EditDescriptionCard/EditDescriptionCard'


interface GetSurveysAction {
  type: typeof SurveyDispatchTypes.GET_SURVEYS_REQUEST
}

interface GetSurveysSuccessAction {
  type: typeof SurveyDispatchTypes.GET_SURVEYS_SUCCESS
  payload: {
    surveys: SurveyObject[]
  }
}

interface GetSurveysFailureAction {
  type: typeof SurveyDispatchTypes.GET_SURVEYS_FAILURE
}

interface DeleteSurveyAction {
  type: typeof SurveyDispatchTypes.DELETE_SURVEY
}

interface DeleteSurveySuccessAction {
  type: typeof SurveyDispatchTypes.DELETE_SURVEY_SUCCESS
  payload: {
    survey: string
  }
}

interface DeleteSurveyFailureAction {
  type: typeof SurveyDispatchTypes.DELETE_SURVEY_FAILURE
}

interface AddSurveyAction {
  type: typeof SurveyDispatchTypes.ADD_SURVEY
}

interface AddSurveySuccessAction {
  type: typeof SurveyDispatchTypes.ADD_SURVEY_SUCCESS
  payload: {
    survey: SurveyObject
  }
}

interface AddSurveyFailureAction {
  type: typeof SurveyDispatchTypes.ADD_SURVEY_FAILURE
}

interface UpdateSurveyLanguageAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_LANGUAGE
}

interface UpdateSurveyLanguageSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_LANGUAGE_SUCCESS
  payload: {
    survey: UpdateSurveyLanguage
  }
}

interface UpdateSurveyLanguageFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_LANGUAGE_FAILURE
}

interface UpdateSurveyNameAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_NAME
}

interface UpdateSurveyNameSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_NAME_SUCCESS
  payload: {
    survey: UpdateSurveyName
  }
}

interface UpdateSurveyNameFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_NAME_FAILURE
}

interface UpdateSurveyDescriptionAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_DESCRIPTION
}

interface UpdateSurveyDescriptionSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_DESCRIPTION_SUCCESS
  payload: {
    survey: UpdateSurveyDescription
  }
}

interface UpdateSurveyDescriptionFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_DESCRIPTION_FAILURE
}

interface UpdateSurveyMailSubjectAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_MAIL_SUBJECT
}

interface UpdateSurveyMailSubjectSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_MAIL_SUBJECT_SUCCESS
  payload: {
    survey: UpdateSurveyMailSubject
  }
}

interface UpdateSurveyMailSubjectFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_MAIL_SUBJECT_FAILURE
}

interface SetSurveySendAfterAppointmentAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_AFTER_APPOINTMENT
}

interface SetSurveySendAfterAppointmentSuccessAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_AFTER_APPOINTMENT_SUCCESS
  payload: {
    surveyId: string
    send: boolean
  }
}

interface SetSurveySendAfterAppointmentFailureAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_AFTER_APPOINTMENT_FAILURE
}

interface SetSurveySendBeforeAppointmentAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_BEFORE_APPOINTMENT
}

interface SetSurveySendBeforeAppointmentSuccessAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_BEFORE_APPOINTMENT_SUCCESS
  payload: {
    surveyId: string
    days: undefined | number
  }
}

interface SetSurveySendBeforeAppointmentFailureAction {
  type: typeof SurveyDispatchTypes.SET_SURVEY_SEND_BEFORE_APPOINTMENT_FAILURE
}

interface AddQuestionAction {
  type: typeof SurveyDispatchTypes.ADD_QUESTION
}

interface AddQuestionSuccessAction {
  type: typeof SurveyDispatchTypes.ADD_QUESTION_SUCCESS
  payload: {
    surveyId: string
    question: ISurveyQuestion
  }
}

interface AddQuestionFailureAction {
  type: typeof SurveyDispatchTypes.ADD_QUESTION_FAILURE
}

interface UpdateQuestionAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTION
}

interface UpdateQuestionSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTION_SUCCESS
  payload: {
    question: ISurveyQuestion
    surveyId: string
  }
}

interface UpdateQuestionFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTION_FAILURE
}

interface DeleteQuestionAction {
  type: typeof SurveyDispatchTypes.DELETE_QUESTION
}

interface DeleteQuestionSuccessAction {
  type: typeof SurveyDispatchTypes.DELETE_QUESTION_SUCCESS
  payload: {
    surveyId: string
    questionId: string
  }
}

interface DeleteQuestionFailureAction {
  type: typeof SurveyDispatchTypes.DELETE_QUESTION_FAILURE
}

interface UpdateQuestionsOrderAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTIONS_ORDER
}

interface UpdateQuestionsOrderSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTIONS_ORDER_SUCCESS
  payload: {
    surveyId: string
    questionIds: string[]
    questions: ISurveyQuestion[]
  }
}

interface UpdateQuestionsOrderFailureAction {
  type: typeof SurveyDispatchTypes.UPDATE_QUESTIONS_ORDER_FAILURE
}

interface CreateSurveyTriggerAction {
  type: typeof SurveyDispatchTypes.CREATE_SURVEY_TRIGGER
}

interface CreateSurveyTriggerSuccessAction {
  type: typeof SurveyDispatchTypes.CREATE_SURVEY_TRIGGER_SUCCESS
  payload: {
    surveyId: string
    trigger: SurveyTrigger
  }
}

interface DeleteSurveyTriggerAction {
  type: typeof SurveyDispatchTypes.DELETE_SURVEY_TRIGGER
}

interface DeleteSurveyTriggerSuccessAction {
  type: typeof SurveyDispatchTypes.DELETE_SURVEY_TRIGGER_SUCCESS
  payload: {
    surveyId: string
    uuid: string
  }
}

interface UpdateSurveyTriggerAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_TRIGGER
}

interface UpdateSurveyTriggerSuccessAction {
  type: typeof SurveyDispatchTypes.UPDATE_SURVEY_TRIGGER_SUCCESS
  payload: {
    surveyId: string
    trigger: SurveyTrigger
  }
}

export type ActionTypes =
  | GetSurveysAction
  | GetSurveysSuccessAction
  | GetSurveysFailureAction
  | DeleteSurveyAction
  | DeleteSurveySuccessAction
  | DeleteSurveyFailureAction
  | AddSurveyAction
  | AddSurveySuccessAction
  | AddSurveyFailureAction
  | UpdateSurveyLanguageAction
  | UpdateSurveyLanguageSuccessAction
  | UpdateSurveyLanguageFailureAction
  | UpdateSurveyNameAction
  | UpdateSurveyNameSuccessAction
  | UpdateSurveyNameFailureAction
  | UpdateSurveyDescriptionAction
  | UpdateSurveyDescriptionSuccessAction
  | UpdateSurveyDescriptionFailureAction
  | UpdateSurveyMailSubjectAction
  | UpdateSurveyMailSubjectSuccessAction
  | UpdateSurveyMailSubjectFailureAction
  | AddQuestionAction
  | AddQuestionSuccessAction
  | AddQuestionFailureAction
  | UpdateQuestionAction
  | UpdateQuestionSuccessAction
  | UpdateQuestionFailureAction
  | DeleteQuestionAction
  | DeleteQuestionSuccessAction
  | DeleteQuestionFailureAction
  | UpdateQuestionsOrderAction
  | UpdateQuestionsOrderSuccessAction
  | UpdateQuestionsOrderFailureAction
  | SetSurveySendAfterAppointmentAction
  | SetSurveySendAfterAppointmentSuccessAction
  | SetSurveySendAfterAppointmentFailureAction
  | SetSurveySendBeforeAppointmentAction
  | SetSurveySendBeforeAppointmentSuccessAction
  | SetSurveySendBeforeAppointmentFailureAction
  | CreateSurveyTriggerAction
  | CreateSurveyTriggerSuccessAction
  | DeleteSurveyTriggerAction
  | DeleteSurveyTriggerSuccessAction
  | UpdateSurveyTriggerAction
  | UpdateSurveyTriggerSuccessAction


  export type UpdateSurveyMailSubject = {
    surveyId: string
    mailSubject: string
  }

 export type UpdateSurveyName = {
    surveyId: string
    name: string
  }

  export type UpdateSurveyDescription = {
    surveyId: string
    description: string
  }


  export type AddQuestion = {
    surveyId: string
    question: string
    order: number
    isMultiline: boolean
    isMultipleChoice: boolean
    // type: string
  }

  export type DeleteQuestion = {
    surveyId: string
    questionId: string
  }

  export type UpdateSurveyLanguage = {
    surveyId: string
    language: string
  }

  export enum SurveyDispatchTypes {
        GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST',
        GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS',
        GET_SURVEYS_FAILURE = 'GET_SURVEYS_FAILURE',
        DELETE_SURVEY = 'DELETE_SURVEY',
        DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS',
        DELETE_SURVEY_FAILURE = 'DELETE_SURVEY_FAILURE',
        ADD_SURVEY = 'ADD_SURVEY',
        ADD_SURVEY_SUCCESS = 'ADD_SURVEY_SUCCESS',
        ADD_SURVEY_FAILURE = 'ADD_SURVEY_FAILURE',
        UPDATE_SURVEY = 'UPDATE_SURVEY',
        UPDATE_SURVEY_SUCCESS = 'UPDATE_SURVEY_SUCCESS',
        UPDATE_SURVEY_FAILURE = 'UPDATE_SURVEY_FAILURE',
        UPDATE_SURVEY_LANGUAGE = 'UPDATE_SURVEY_LANGUAGE',
        UPDATE_SURVEY_LANGUAGE_SUCCESS = 'UPDATE_SURVEY_LANGUAGE_SUCCESS',
        UPDATE_SURVEY_LANGUAGE_FAILURE = 'UPDATE_SURVEY_LANGUAGE_FAILURE',
        UPDATE_SURVEY_NAME = 'UPDATE_SURVEY_NAME',
        UPDATE_SURVEY_NAME_SUCCESS = 'UPDATE_SURVEY_NAME_SUCCESS',
        UPDATE_SURVEY_NAME_FAILURE = 'UPDATE_SURVEY_NAME_FAILURE',
        UPDATE_SURVEY_DESCRIPTION = 'UPDATE_SURVEY_DESCRIPTION',
        UPDATE_SURVEY_DESCRIPTION_SUCCESS = 'UPDATE_SURVEY_DESCRIPTION_SUCCESS',
        UPDATE_SURVEY_DESCRIPTION_FAILURE = 'UPDATE_SURVEY_DESCRIPTION_FAILURE',
        UPDATE_SURVEY_MAIL_SUBJECT = 'UPDATE_SURVEY_MAIL_SUBJECT',
        UPDATE_SURVEY_MAIL_SUBJECT_SUCCESS = 'UPDATE_SURVEY_MAIL_SUBJECT_SUCCESS',
        UPDATE_SURVEY_MAIL_SUBJECT_FAILURE = 'UPDATE_SURVEY_MAIL_SUBJECT_FAILURE',
        SET_SURVEY_SEND_AFTER_APPOINTMENT = 'SET_SURVEY_SEND_AFTER_APPOINTMENT',
        SET_SURVEY_SEND_AFTER_APPOINTMENT_SUCCESS = 'SET_SURVEY_SEND_AFTER_APPOINTMENT_SUCCESS',
        SET_SURVEY_SEND_AFTER_APPOINTMENT_FAILURE = 'SET_SURVEY_SEND_AFTER_APPOINTMENT_FAILURE',
        SET_SURVEY_SEND_BEFORE_APPOINTMENT = 'SET_SURVEY_SEND_BEFORE_APPOINTMENT',
        SET_SURVEY_SEND_BEFORE_APPOINTMENT_SUCCESS = 'SET_SURVEY_SEND_BEFORE_APPOINTMENT_SUCCESS',
        SET_SURVEY_SEND_BEFORE_APPOINTMENT_FAILURE = 'SET_SURVEY_SEND_BEFORE_APPOINTMENT_FAILURE',
        ADD_QUESTION = 'ADD_QUESTION',
        ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS',
        ADD_QUESTION_FAILURE = 'ADD_QUESTION_FAILURE',
        UPDATE_QUESTION = 'UPDATE_QUESTION',
        UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS',
        UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE',
        DELETE_QUESTION = 'DELETE_QUESTION',
        DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS',
        DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE',
        UPDATE_QUESTIONS_ORDER = 'UPDATE_QUESTIONS_ORDER',
        UPDATE_QUESTIONS_ORDER_SUCCESS = 'UPDATE_QUESTIONS_ORDER_SUCCESS',
        UPDATE_QUESTIONS_ORDER_FAILURE = 'UPDATE_QUESTIONS_ORDER_FAILURE',
        CREATE_SURVEY_TRIGGER = 'CREATE_SURVEY_TRIGGER',
        CREATE_SURVEY_TRIGGER_SUCCESS = 'CREATE_SURVEY_TRIGGER_SUCCESS',
        DELETE_SURVEY_TRIGGER = 'DELETE_SURVEY_TRIGGER',
        DELETE_SURVEY_TRIGGER_SUCCESS = 'DELETE_SURVEY_TRIGGER_SUCCESS',
        UPDATE_SURVEY_TRIGGER = 'UPDATE_SURVEY_TRIGGER',
        UPDATE_SURVEY_TRIGGER_SUCCESS = 'UPDATE_SURVEY_TRIGGER_SUCCESS',
      }
